$(document).ready(function () {
    var isHomePage = $('[name="isHomePage"]').val() === "true";

    if (!isHomePage) {
        return;
    }

    var canonicalEvents = require("../analytics/canonicalEvents");

    var $deliveryMethodInput = $('[name="checkoutDeliveryMethod"]');

    var deliveryMethod = $deliveryMethodInput.val() || null;
    var storeId = $('[name="selectedStoreId"]').val() || null;

    var selectedStore = storeId
        ? canonicalEvents.toStorePayload({
              ID: storeId,
              name: $('[name="selectedStoreName"]').val() || null,
              city: $('[name="selectedStoreCity"]').val() || null,
              province: $('[name="selectedStoreState"]').val() || null,
          })
        : null;

    canonicalEvents.pushCanonicalEvent("page_view", {
        surface: "home",
        source: "home_baseline",
        selected_store: selectedStore,
        delivery_method: deliveryMethod,
        page_type: "home",
    });
});
